import { Component, EventEmitter, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { GradingScheduleList } from '../../../../../shared/interface/grading-schedule.interface';
import { GenericFormGroupComponent } from '../../../../../forms/generic-form-group.component';
import { GradingScheduleService } from '../../../../../shared/grading-schedule.service';
import { AlertService } from '../../../../../shared/services/alert.service';
import { FormControl, Validators } from '@angular/forms';
import { QuestionDefinition, SelectInputType } from '../../../../../forms/form.types';
import { Observable } from 'rxjs/Observable';
import { ScheduleTerm } from '../../../../../shared/interface/term-interface';
import { of } from 'rxjs';
@Component({
    selector: 'app-registrar-admin-maintenance-schedule-batch-process',
    templateUrl: './schedule-batch-process.component.html',
    styleUrls: ['./schedule-batch-process.component.scss']
})
export class ScheduleBatchProcessComponent extends GenericFormGroupComponent implements OnInit {
    constructor(
        public gradingScheduleService: GradingScheduleService,
        public alertService: AlertService,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
        this.getAllOpenForGrading();
    }

    controls: {
        termCode: FormControl<string>;
    };

    questions: {
        termCode: QuestionDefinition;
    };

    gradingSchedule: Array<GradingScheduleList>;

    private options: Array<ScheduleTerm> = [];

    @Output() batchCloseComplete = new EventEmitter<boolean>();
    ngOnInit(): void {
        //
        this.initControlsAndQuestions();
    }

    private initControlsAndQuestions() {
        this.controls = {
            termCode: new FormControl<string>('', Validators.required)
        };
        this.createFormGroup(this.controls);

        this.questions = {
            termCode: {
                input: {
                    discriminator: 'SELECT',
                    property: 'termCode',
                    label: 'Select a Term',
                    control: this.controls.termCode,
                    optionsCallBack: {
                        this: this,
                        function: this.renderOptions
                    },
                    required: true
                }
            }
        };
    }

    private renderOptions(): Observable<Array<ScheduleTerm>> {
        if (this.gradingSchedule?.length) {
            this.options = this.gradingSchedule?.map((m) => {
                return {
                    text: m.termDescription,
                    value: m.termCode
                } as ScheduleTerm;
            });
        }
        return of(this.options);
    }

    getAllOpenForGrading(): void {
        this.gradingScheduleService.getAllOpenForGrading().subscribe((response: Array<GradingScheduleList>) => {
            if (response) {
                this.gradingSchedule = response;
                (this.questions.termCode.input as SelectInputType).updateOptions = true;
            }
        });
    }

    onShowSaveButton(): boolean {
        const valueList = this.getFormValue<GradingScheduleList>();
        return !!valueList?.termCode;
    }

    onSaveData() {
        const valueList = this.getFormValue<GradingScheduleList>();

        this.gradingScheduleService
            .batchUpdateCloseSchedule(valueList?.termCode)
            .subscribe((response: Array<GradingScheduleList>) => {
                //after done need to update the list open and close;
                this.batchCloseComplete.emit(true);
                this.onCancel();
                this.getAllOpenForGrading();
            });
    }

    onCancel() {
        this.clearAllValuesAndMarkPristine();
    }
}
